import { ReactNode, useRef, useState } from "react"
import { OfflineAnonMsg } from "../models/api/OfflineMsg";
import { OfflineMsgType, OfflineMsgTypeAdv } from "../models/api/OfflineMsgType";
import { appConfig } from "../models/constants"
import { ProgStatus } from "../models/utilTypes";
import ApiService from "../services/ApiService";
import { makeId } from "../services/HelperService";

type AnonParams = {
   userUid: string,
   disabled: boolean 
}

export const AnonMsgBox = (props:{data: AnonParams})=>{
    
    const inputRef = useRef<HTMLTextAreaElement>(null)
    const [sendStatus, setSendStatus] = useState<ProgStatus>('INIT');

    function sendAnonMsg(){

        if(sendStatus == 'SUCCESS' || inputRef.current!.value.length == 0 ){
            return;
        }

        setSendStatus('LOADING');
        const anonMsg: OfflineAnonMsg = {
            type: OfflineMsgTypeAdv.ANON_CHAT,
            data: {
                epoch: Date.now(),
                from: `Anon-${makeId(8)}`,
                msg: inputRef.current!.value,
                tag: 'Gen',
                toUid: props.data.userUid
            }
        }

        ApiService.sendAnonMsg(anonMsg)
        .then((resp)=>{
            setSendStatus('SUCCESS');
            console.log('Msg sent successfully')
            inputRef.current!.value = ''
        })
        .catch(err => {
            setSendStatus('FAILED')
            console.error(err)
        })

       

    }

    function getStatus(): ReactNode {


        switch (sendStatus) {

            case 'SUCCESS' : return <span className="material-icons" style={{ color: 'green' }}>task_alt</span>

            case 'LOADING': return <progress className="pure-material-progress-circular" />
                break;

            default: return 'Send Anonymously'

        }
    }

    return(
        <div className="flex-column center-both" >
            <h3>Say to me Anonymously</h3>
            <textarea ref={inputRef} name="" className='text-anon-msg' maxLength={appConfig.IM_TEXT_LENGTH}
                disabled={props.data.disabled} />
            <button className='button-5 button-fixed'
                    onClick={sendAnonMsg}
                    disabled={props.data.disabled}
                    style={{ width: 216, marginTop: 10, marginBottom: 10 }}
                >{getStatus()}</button>
             { props.data.disabled && <h4 style={{padding: 8}} >User has disabled Anonymous texting</h4>}
        </div>
    )
}